import { render, staticRenderFns } from "./CertSearch.vue?vue&type=template&id=68eb48b1&scoped=true&"
import script from "./CertSearch.vue?vue&type=script&lang=js&"
export * from "./CertSearch.vue?vue&type=script&lang=js&"
import style0 from "./CertSearch.vue?vue&type=style&index=0&id=68eb48b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb48b1",
  null
  
)

export default component.exports